// extracted by mini-css-extract-plugin
export default {"widthItems":"DemoModal_widthItems_kB79f"};